<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <JobListFiltersForm
      ref="job-list-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'
import JobListFiltersForm from '@/components/jobs/form/JobListFiltersForm.vue'

export default {
  name: 'JobListFilters',
  components: {
    JobListFiltersForm,
    BaseFiltersSideBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['job-list-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>

<style lang="scss">
</style>
